import { render, staticRenderFns } from "./InputLayout.component.vue?vue&type=template&id=aace50ea"
import script from "./InputLayout.component.vue?vue&type=script&lang=js"
export * from "./InputLayout.component.vue?vue&type=script&lang=js"
import style0 from "./InputLayout.component.vue?vue&type=style&index=0&id=aace50ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports